export default __webpack_public_path__ + "bg-desktop.bb0404.png";